// extracted by mini-css-extract-plugin
module.exports = {"center":"RewardTable_center__1vuVa","table":"RewardTable_table__3-qEb"};